"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tutorial = require("./Tutorial");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var OpenButton = function OpenButton(_ref) {
  var children = _ref.children;

  var context = _react.default.useContext(_Tutorial.TutorialContext);

  if (context === undefined) {
    console.error('<OpenButton> component must be within a <Tutorial>');
    return null;
  }

  if (typeof children !== 'function') {
    console.error('Child passed into <OpenButton> must be a function');
    return null;
  }

  return children(context.showTutorial);
};

OpenButton.propTypes = {
  children: _propTypes.default.func.isRequired
};
var _default = OpenButton;
exports.default = _default;